import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape( {
  firstName: Yup.string()
  .min( 2, 'Too Short!' )
  .max( 50, 'Too Long!' )
  .required( '* First name is Required.' ),

  lastName: Yup.string()
  .min( 2, 'Too Short!' )
  .max( 50, 'Too Long!' )
  .required( '* Surname is Required.' ),

  phone: Yup.string()
  .required( '* Phone number is Required.' ),

  email: Yup.string()
  .email( '* Enter a Valid Email.' )
  .required( '* Email is Required.' ),

  guests: Yup.string(),
  date: Yup.string().matches(/[0-3][0-9]\/[0-1][0-9]\/20[0-9][0-9]$/, {
    excludeEmptyString: true,
    message: 'Please enter a date formatted like so: 01/02/2021'
  }),
  eventType: Yup.string(),
  noDateYet: Yup.boolean(),
  details: Yup.string(),
  referral: Yup.string()
  .required( '* Referral is Required.' ),
  subscribe: Yup.boolean(),

} );

const encode = ( data ) => {
  return Object.keys( data )
  .map( key => encodeURIComponent( key ) + '=' + encodeURIComponent( data[ key ] ) )
  .join( '&' )
};

function EnquireForm() {

  return (
    <>
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          guests: '',
          date: '',
          eventType: '',
          noDateYet: false,
          details: '',
          referral: '',
          subscribe: false,
        }}
        validationSchema={validationSchema}
        onSubmit={( values, { setSubmitting } ) => {

          fetch( '/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode( {
              'form-name': 'enquire-form',
              ...values,
            } ),
          } )
          .then( () => {
            alert( 'Thanks! We have received your message and will get back to you ASAP.' );
            setSubmitting( false )
          } )
          .catch( error => {
            alert( 'Something went wrong! Could you please try again or email us directly.' );
            setSubmitting( false )
          } );

          fetch( 'https://api.priava.com/api/rest/v2/thirdparty/opportunity/save', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${process.env.GATSBY_PRIAVA_API_KEY}`,
              'TenantRegion': 'APAC'
            },
            body: JSON.stringify( {
                'OpportunityName': 'The Marion - Web enquiry',
                'OpportunityStartDate': `${values.date} 09:00`,
                'OpportunityEndDate': `${values.date} 17:30`,
                'Pax': values.guests,
                'Owner': {
                  'Email': 'willmcl@gmail.com'
                },
                'IdentifiedBy': {
                  'Email': 'willmcl@gmail.com'
                },
                'EventType': {
                  'Name': values.eventType
                },
                'OpportunitySource': {
                  'Name': 'Website - The Marion'
                },
                'OpportunityStatus': {
                  'Name': 'Active'
                },
                'OpportunityContacts': [
                  {
                    'IsPrimary': true,
                    'Firstname': values.firstName,
                    'Email': values.email,
                    'Phone': values.phone,
                    'Lastname': values.lastName,
                    'ContactType': {
                      'Name': 'Contact'
                    }
                  }
                ]
              }
            ),
          } )
          .then(response => response.json())
          .then(data => {
            // console.log('Success:', data);
            setSubmitting( false );
          })
          .catch( error => {
            console.log('Error:', error );
            setSubmitting( false );
          } );


        }}>
        {( { isSubmitting, values, handleChange } ) => (
          <Form className='form'
            method="post"
            name='enquire-form'
            data-netlify='true'
            data-netlify-honeypot='bot-field'
          >
            <h2>Your Details</h2>
            <div className='two-col-fields'>
              <div className='field-holder'>
                <label htmlFor='firstName' className='label'>First Name</label>
                <Field
                  className='input'
                  type='text'
                  name='firstName'
                  placeholder="First Name*"
                />
                <ErrorMessage className="errorMsg" name="firstName" component="small"/>
              </div>
              <div className='field-holder'>
                <label htmlFor='lastName' className='label'>Surname</label>
                <Field
                  className='input'
                  type='text'
                  name='lastName'
                  placeholder="Surname*"
                />
                <ErrorMessage className="errorMsg" name="lastName" component="small"/>
              </div>
            </div>
            <div className='field-holder'>
              <label htmlFor='email' className='label'>Email</label>
              <Field
                className='input'
                type='text'
                name='email'
                placeholder="Email*"
              />
              <ErrorMessage className="errorMsg" name="email" component="small"/>
            </div>
            <div className='two-col-fields'>
              <div className='field-holder'>
                <label htmlFor='phone' className='label'>Phone no.</label>
                <Field
                  className='input'
                  type='text'
                  name='phone'
                  placeholder="Phone no.*"
                />
                <ErrorMessage className="errorMsg" name="phone" component="small"/>
              </div>
            </div>

            <h2>Event Details</h2>
            <div className='two-col-fields'>
              <div className='field-holder'>
                <label htmlFor='guests' className='label'>Guests</label>
                <Field
                  className='input'
                  type='text'
                  name='guests'
                  placeholder="Guests"
                />
                <ErrorMessage className="errorMsg" name="guests" component="small"/>
              </div>
              <div className='field-holder'>
                <label htmlFor='date' className='label'>Date</label>
                <Field
                  className='input'
                  type='text'
                  name='date'
                  placeholder="Date"
                />
                <ErrorMessage className="errorMsg" name="date" component="small"/>
              </div>
            </div>

            <div className='two-col-fields'>

              <div className='field-holder select'>
                <label htmlFor='eventType' className='label'>Event type</label>
                <Field as="select" name="eventType">
                  <option value="" disabled>Event type</option>
                  <option value="Wedding">Wedding</option>
                  <option value="Corporate">Corporate</option>
                  <option value="Private">Private</option>
                </Field>
                <ErrorMessage className="errorMsg" name="eventType" component="small"/>
              </div>

              <label htmlFor='noDateYet' className="checkbox">
                <Field type="checkbox" id="noDateYet" name="noDateYet" checked={values.noDateYet} onChange={handleChange}/>
                <div className="checkmark"/>
                <span className="label">Date undecided</span>
              </label>
            </div>

            <div className='field-holder'>
              <label htmlFor='details' className='label'>Other Details</label>
              <Field
                className='input-textarea'
                name='details'
                component='textarea'
                rows='3'
                placeholder="Other Details"
              />
              <ErrorMessage className="errorMsg" name="details" component="small"/>
            </div>

            <div className='two-col-fields'>
              <div className='field-holder'>
                <div className="select">
                  <label htmlFor='referral' className='label'>How did you hear about us?</label>

                  <Field as="select" name="referral">
                    <option value="" disabled>How did you hear about us?*</option>
                    <option value="attended-event">Attended event</option>
                    <option value="google-search">Google search</option>
                    <option value="previous-dining-experience">Previous dining experience</option>
                    <option value="referral">Referral</option>
                    <option value="social-media-fb">Social Media – Facebook</option>
                    <option value="social-media-instagram">Social Media – Instagram</option>
                  </Field>
                </div>
                <ErrorMessage className="errorMsg" name="referral" component="small"/>
                </div>
            </div>

            <label htmlFor='subscribe' className="checkbox">
              <Field type="checkbox" id="subscribe" name="subscribe" checked={values.subscribe} onChange={handleChange}/>
              <div className="checkmark"/>
              <span className="label">Yes, I would like to stay
                up-to-date with The Marion and receive newsletters</span>
            </label>

            <div className="submit-holder">
              <input name='submit' type='submit' disabled={isSubmitting} value='Send Enquiry'
                className='button dark'/>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default EnquireForm;
